import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import Discover from "@/pages/Discover";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Validator from "@/pages/Validator";
import IdeaGenerator from "@/pages/IdeaGenerator";
import TrendRadar from "@/pages/TrendRadar";
import Resources from "@/pages/Resources";
import PainPoints from "@/pages/PainPoints";
import RevenueCalculator from "@/pages/RevenueCalculator";
import BuildPlanner from "@/pages/BuildPlanner";
import CompetitorRadar from "@/pages/CompetitorRadar";
import Workspace from "@/pages/Workspace";
import Community from "@/pages/Community";
import PostDetail from "@/pages/PostDetail";
import Leaderboard from "@/pages/Leaderboard";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import ReportView from "@/pages/ReportView";
import Compare from "@/pages/Compare";
import NotFound from "@/pages/NotFound";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/opportunities/:slug" element={<OpportunityDetail />} />
        <Route path="/trends" element={<TrendRadar />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/pain-points" element={<PainPoints />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/:id" element={<PostDetail />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/revenue" element={<RevenueCalculator />} />

        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
        <Route path="/validate" element={<ProtectedRoute><Validator /></ProtectedRoute>} />
        <Route path="/generate" element={<ProtectedRoute><IdeaGenerator /></ProtectedRoute>} />
        <Route path="/build-planner" element={<ProtectedRoute><BuildPlanner /></ProtectedRoute>} />
        <Route path="/competitor" element={<ProtectedRoute><CompetitorRadar /></ProtectedRoute>} />
        <Route path="/reports/:id" element={<ProtectedRoute><ReportView /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
